import { Tag } from '@caudena/web-platform'
import styled from '@emotion/styled'

export const SeverityTag = styled(Tag)<{
  $width?: string
  $minWidth?: number
}>`
  width: ${({ $width = 'auto' }) => $width};
  min-width: ${({ $minWidth }) =>
    $minWidth != null ? `${$minWidth}px` : 'auto'};
`
